var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modals',{attrs:{"title":'Create a scheduled move',"display":_vm.display},on:{"show":_vm.closeModal},scopedSlots:_vm._u([{key:"modal-content",fn:function(){return [_c('div',{staticClass:"schedule-create"},[_c('ScheduleAddEditForm',{staticClass:"schedule-create__fields",on:{"hasError":_vm.updateHasErrorModal,"hasDateError":_vm.updateHasDateError},model:{value:(_vm.schedule),callback:function ($$v) {_vm.schedule=$$v},expression:"schedule"}}),_c('div',{staticClass:"schedule-create__moved"},[_c('div',{staticClass:"schedule-create__moved-txt"},[_vm._v(" List of client(s) to be moved: ")]),_c('ul',{staticClass:"schedule-create__moved-list"},_vm._l((_vm.customers),function(id){return _c('li',{key:id,staticClass:"schedule-create__moved-list-item"},[(_vm.customerById(id))?_c('div',[_vm._v(" "+_vm._s(_vm.customerById(id).displayName || _vm.customerById(id).dealershipGroup)+" ")]):_vm._e()])}),0)])],1)]},proxy:true},{key:"modal-footer",fn:function(){return [_c('ButtonGroup',{attrs:{"items":[
				{
					id: 'saveButtonModal',
					className: 'btn--primary',
					labelText: 'Create a Scheduled Move',
					type: 'submit',
					disabled: _vm.disabledSaveActionButton,
					btnClick: _vm.saveAction
				},
				{
					id: 'cancelButtonModal',
					className: 'btn--link',
					labelText: 'Cancel',
					btnClick: _vm.closeModal
				}
			]}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }